import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const ITEMS = [
  {
    q: "Do I need to be home for the appointment?",
    a: "Not for exterior cleaning — we just need access to your yard and outdoor faucets. For interior windows, we'll need someone to let us in.",
  },
  {
    q: "What if it rains the day of my service?",
    a: "If conditions look bad we'll reach out to reschedule at no charge. Light rain doesn't affect a properly cleaned window — the soap and rinse leave behind a coating that protects from spots.",
  },
  {
    q: "How is your water-fed pole different?",
    a: "Our pole runs purified, deionized water — meaning it dries with zero residue or spotting. It also reaches second-story windows and skylights without ladders, which is safer and faster. It's our standard method for most jobs.",
  },
  {
    q: "How long does a typical service take?",
    a: "An average single-story home (around 15–20 windows) takes 60–90 minutes. Larger homes and commercial jobs scale from there.",
  },
  {
    q: "Do you do screens and solar panels too?",
    a: "Yes. Screens are removed, washed, and reinstalled — priced per screen as an add-on, so let us know your count up front. Solar panels are rinsed with deionized water for a streak-free finish that restores efficiency.",
  },
  {
    q: "What does your satisfaction guarantee cover?",
    a: "If you spot a streak or missed area within 24 hours of service, we come back and re-clean it free of charge. Period.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-[#00B4D8] font-bold">
            Frequently asked
          </span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-extrabold text-[#0B2542] leading-tight">
            Good questions, clear answers.
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="mt-12 space-y-3"
          data-testid="faq-accordion"
        >
          {ITEMS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-blue-100 bg-white px-6 data-[state=open]:border-[#00B4D8]/50 data-[state=open]:shadow-[0_8px_24px_rgba(15,76,129,0.06)] transition-all"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-5 font-[Outfit] font-semibold text-left text-[#0B2542] hover:no-underline text-base sm:text-lg">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-slate-600 text-base leading-relaxed">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
